<template>
	<div class="assets-filter" v-bind:class="'assets-filter--' + layout">
		<div class="assets-filter__centraliser" v-bind:class="{
			'page-container': centralise
		}">

			<div class="grid grid--middle grid--g0" v-bind:class="{
				'grid--s0 grid--auto grid--v-spread-items': layout === 'horizontal',
				'grid--s24': layout === 'vertical',
			}">		<!-- <attr class="grid--s0 grid--auto grid--v-spread-items grid--s24" /> -->

				<div v-if="includeRegions" class="assets-filter__group assets-filter__group--regions clickable grid__item " v-bind:class="{
					'o--2n' : layout === 'vertical',
					'assets-filter__group--regions--active' : showRegionSelector,
				}" @click.stop="showRegionSelector = !showRegionSelector; trackEvent([
					'game-region-filter-clicked',
					showRegionSelector ? 'opened' : 'closed',
					$root.$data.user ? $root.$data.user.trackName : null,
					0,
					false
				])">		<!-- <attr class="o--2n" /> -->

					<div class="assets-filter__icon-wrap fc-pal--blue" :class="{
						'hide' : layout == 'vertical'
						// <attr class='hide' />
					}">
						<span class="fonticon fonticon--globe assets-filter__icon fs--21c mb--16c">
							<span class="assets-filter__badge">{{filters.regions.length}}</span>
						</span>
						<div class="assets-filter__icon-text">Filter by Region</div>
					</div>

					<div v-if="layout === 'vertical'" class="assets-filter__group-title">Filter by region:</div>

					<RegionSelector v-show="showRegionSelector || layout == 'vertical'" class="assets-filter__region-selector" v-model="filters.regions" :isMultiSelect="true" :hasSelectedSummary="true" @click.native.stop @input="filterChanged('regions')">
						<template v-slot:footerAction>
							<span class="link link--action" @click="filters.regions = []; filterChanged('regions'); showRegionSelector = false;">View all regions</span>
						</template>
					</RegionSelector>


				</div>
				<div class="assets-filter__group grid__item " v-bind:class="{
					'o--3n': layout === 'vertical',
				}">		<!-- <attr class="o--3n" /> -->

					<div v-if="layout === 'vertical'" class="assets-filter__group-title">Filter by game type:</div>

					<div class="grid grid--s0" v-bind:class="{
						'grid--g40--desk grid--g20--ltab grid--auto': layout === 'horizontal',
					}">		<!-- <attr class="grid--g40--desk grid--g20--ltab grid--auto" /> -->
						<div class="grid__item" v-if="includeSort">
							<checkbox-field v-model="filters.sort" class="assets-filter__type" v-bind:class="{
								'assets-filter__new' : layout === 'horizontal'
							}" v-on:input="filterChanged('releaseDate')">
								<option :value="{'regionalReleaseDate': 'desc'}">Most <br />Recent</option>
							</checkbox-field>
						</div>
						<div class="grid__item">
							<checkbox-field v-model="filters.type" class="assets-filter__type" v-bind:class="{
								'assets-filter__slot' : layout === 'horizontal'
							}" v-on:input="filterChanged('slots')">
								<option value='type-slots'>Slots</option>
							</checkbox-field>
						</div>
						<div class="grid__item">
							<checkbox-field v-model="filters.type" class="assets-filter__type" v-bind:class="{
								'assets-filter__table' : layout === 'horizontal'
							}" v-on:input="filterChanged('table')">
								<option value='type-table'>Table</option>
							</checkbox-field>
						</div>
						<div class="grid__item">
							<checkbox-field v-model="filters.type" class="assets-filter__type" v-bind:class="{
								'assets-filter__jackpots' : layout === 'horizontal'
							}" v-on:input="filterChanged('jackpots')">
								<option value='type-jackpots'>Jackpots</option>
							</checkbox-field>
						</div>
						<div class="grid__item">
							<checkbox-field v-model="filters.type" class="assets-filter__type" v-bind:class="{
								'assets-filter__video-poker' : layout === 'horizontal'
							}" v-on:input="filterChanged('video-poker')">
								<option value='type-video-poker'>Video <br />Poker</option>
							</checkbox-field>
						</div>
						<div class="grid__item">
							<checkbox-field v-model="filters.type" class="assets-filter__type" v-bind:class="{
								'assets-filter__egm' : layout === 'horizontal'
							}" v-on:input="filterChanged('egm')">
								<option value='type-egm'>EGM</option>
							</checkbox-field>
						</div>
						<div class="grid__item">
							<checkbox-field v-model="filters.type" class="assets-filter__type" v-bind:class="{
								'assets-filter__instant-win' : layout === 'horizontal'
							}" v-on:input="filterChanged('instant-win')">
								<option value='type-instant-win'>Instant <br />Win</option>
							</checkbox-field>
						</div>
					</div>

				</div>
				<div v-if="layout === 'horizontal'" class="assets-filter__group grid__item" v-bind:class="{
					'grid__item--space w--0': layout === 'horizontal',
				}">		<!-- <attr class="grid__item--space w--0" /> -->

					<volatility-rating volatility-title="Search by Volatility" :read-only="false" :volatility-slug="filters.volatility" v-on:volatilityChanged="setVolatility"></volatility-rating>

				</div>
				<div class="assets-filter__group assets-filter__group--search clickable grid__item " v-bind:class="{
					'o--1n' : layout === 'vertical',
					'assets-filter__group--search--active' : showSearch,
				}" @click.stop="showSearch = !showSearch">		<!-- <attr class="o--1n" /> -->

					<div class="assets-filter__icon-wrap" :class="{
						'hide' : layout == 'vertical'
						// <attr class='hide' />
					}">
						<span class="fonticon fonticon--search assets-filter__icon fs--21c mb--16c"></span>
						<div class="assets-filter__icon-text">Search</div>
					</div>

					<div class="assets-filter__search" v-show="showSearch || layout == 'vertical'" @click.stop >
						<autocomplete ref="search" placeholder="Search for a game..." :items="autocompleteData" @input="gameSearched"></autocomplete>
					</div>

				</div>
			</div>

		</div>
	</div>
</template>

<script>
import { cloneDeep, map } from 'lodash';

import CheckboxField from '../atoms/CheckboxField';
import RegionSelector from '../atoms/RegionSelector'
import VolatilityRating from '../molecules/VolatilityRating'
import Autocomplete from '../molecules/Autocomplete'

export default {
	name: 'AssetsFilter',
	components: {
		CheckboxField,
		RegionSelector,
		VolatilityRating,
		Autocomplete
	},
	data () {
		return {
			showRegionSelector: false,
			showSearch: false,
			filtersDefault: {
				regions: [this.$root.userSelectedRegion.key],
				sort: [
					{'regionalReleaseDate': 'desc'}
				],
				type: [
				],
				volatility: null,
				search: null
			},
			filters: null
		}
	},
	props: {
		isVertical: {
			type: Boolean,
			default: true
		},
		centralise: {
			type: Boolean,
			default: true
		},
		includeSort: {
			type: Boolean,
			default: true
		},
		includeRegions: {
			type: Boolean,
			default: true
		},
		autocompleteData: Array,
	},
	computed: {
		layout: function()
		{
			var self = this;
			return self.isVertical || self.$mq === 'mob' || self.$mq === 'ptab' ? 'vertical' : 'horizontal';
		}
	},
	watch: {
		'$root.userSelectedRegionKey' : function(to, from)
		{
			this.filtersDefault.regions = [this.$root.userSelectedRegion.key];
			this.filters.regions = [this.$root.userSelectedRegion.key];
			this.filterChanged('regions');
		}
	},
	created: function()
	{
		this.$eventBus.$on('window-click', this.closeAllPopups);
		this.filters = cloneDeep(this.filtersDefault);
	},
	mounted: function()
	{
	},
	beforeDestroy: function()
	{
		this.$eventBus.$off('window-click', this.closeAllPopups);
	},
	methods: {
		closeAllPopups()
		{
			this.showRegionSelector = false;
			this.showSearch = false;
		},
		filterChanged(name)
		{
			var self = this;
			self.$emit('filterChanged', self.filters);
			self.trackEvent([
				'filter-changed',
				name,
				self.$root.$data.user ? self.$root.$data.user.trackName : null,
				0,
				false
			]);
		},
		setVolatility(volatility)
		{
			var self = this;
			self.filters.volatility = self.filters.volatility != volatility ? volatility : null;
			self.$emit('filterChanged', self.filters);
			self.trackEvent([
				'filter-changed',
				'volatility',
				self.$root.$data.user ? self.$root.$data.user.trackName : null,
				0,
				false
			]);
		},
		gameSearched(gameId)
		{
			var self = this;
			self.filters.search = gameId;
			self.$emit('filterChanged', self.filters);

			// If not resetting...
			if(gameId !== null)
			{
				self.trackEvent([
					'filter-changed',
					'game-search',
					self.$root.$data.user ? self.$root.$data.user.trackName : null,
					0,
					false
				]);
			}
		},
		reset()
		{
			var self = this;
			self.filters = cloneDeep(self.filtersDefault);
			self.filters.regions = [this.$root.userSelectedRegion.key];
			self.$refs.search.setResult(self.filters.search);
			self.$emit('filterChanged', self.filters);
		}
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".assets-filter";
	#{$c}
	{
		&--vertical
		{
			padding-top: rem(24);
			padding-bottom: rem(24);
		}

		&__centraliser
		{
			#{$c}--horizontal &
			{
				padding-left: 0;
				padding-right: 0;
			}
		}

		&__group
		{
			position: relative;

			#{$c}--horizontal &
			{
				padding-top: rem(24);
				padding-bottom: rem(24);
				display: flex;
				align-items: center;

				@include media(desk)
				{
					padding-left: rem(48);
					padding-right: rem(48);
				}

				@include media(ltab)
				{
					padding-left: rem(24);
					padding-right: rem(24);
				}
			}

			&--regions,
			&--search
			{
				#{$c}--horizontal &
				{
					margin-right: -1px;

					&--active
					{
						color: palette(blue);
						box-shadow: inset 0 0 0 1px palette(lighter-grey), 0 4px 8px rgba(0,0,0,0.05);

						&:after
						{
							content: '';
							display: block;
							position: absolute;
							height: 5px;
							left: 1px;
							right: 1px;
							top: calc(100% - 10px);
							background-color: palette(white);
							z-index: 100;
						}
					}
				}
			}

			&:not(:first-child):before
			{
				#{$c}--horizontal &
				{
					content: "";
					position: absolute;
					display: block;
					width: 1px;
					height: 100%;
					background-color: palette(lighter-grey);
					top: 0;
					left: 0;
				}
			}

			&-title
			{
				@include extend(heading-font-bold);

				#{$c}--vertical &
				{
					font-size: 16px;
					margin-bottom: 1em;
				}
			}
		}

		&__icon
		{
			position: relative;

			&-wrap
			{
				#{$c}--horizontal &
				{
					font-size: 10px;
					line-height: 1.2;
					text-align: center;
					text-indent: 0;
					padding-left: 0;
				}
			}

			&-text
			{
				#{$c}--horizontal &
				{
					@include extend(lato-bold);
					text-transform: uppercase;
				}
			}
		}

		&__badge
		{
			@include extend(badge);
			@include extend(bgc-pal--red);
			@include extend(lato-bold);
			font-size: 10px;
			position: absolute;
			top: 0;
			right: 0;
			transform: translateX(50%) translateY(-50%);
			z-index: 1;
		}

		&__region-selector
		{
			#{$c}--horizontal &
			{
				position: absolute;
				left: 0;
				top: calc(100% - 8px);
				box-shadow: inset 0 0 0 1px palette(lighter-grey), 0 4px 8px rgba(0,0,0,0.05);
				z-index: 99;
			}

			#{$c}--vertical &
			{
				max-width: none;
				width: 100%;
				padding: 0;
			}
		}

		&__type.field--checkbox 			// <--- Increase specificity
		{
			#{$c}--horizontal &
			{
				line-height: 0;
			}

			#{$c}--vertical &
			{
				background-color: palette(white);
				padding: 13px 15px;
				border: 1px solid palette('divider');
			}

			#{$c}--vertical :not(:first-child) > &
			{
				border-top-width: 0;
			}

			.field__sub-label
			{
				@extend .assets-filter__icon-wrap;

				#{$c}--vertical &
				{
			    text-indent: -23px;
			    padding-left: 23px;
				}

				&:before
				{
					#{$c}--vertical &
					{
						font-size: 6px;
						width: 17px;
						height: 17px;
						margin-right: 6px;
						border: 2px solid #8DC8E8;
						border-radius: 50%;
					}

					#{$c}--horizontal &
					{
						width: auto;
						height: auto;
						border-width: 0;
						margin-bottom: 0.5em;
						display: flex !important;
						@include extend(block-center);
						color: palette(grey);
					}

					@include media(ltab) { font-size: rem(24); }
					@include media(desk) { font-size: rem(32); }
				}

				> *
				{
					@extend .assets-filter__icon-text;
					color: palette(font);

					#{$c}--vertical &
					{
						br
						{
							display: none;
						}
					}
				}
			}

			.field__element:checked + .field__sub-label
			{
				&:before
				{
					color: palette(blue);
				}

				#{$c}--vertical &
				{
					&:before
					{
						content: "\2B24";
  				}
				}

				#{$c}--horizontal &
				{
					> *
					{
						color: palette(blue);
					}
				}
			}

			&#{$c}__new .field__sub-label:before
			{
				@include extend(fonticon);
				@include extend(fonticon--new);
			}
			&#{$c}__slot .field__sub-label:before
			{
				@include extend(fonticon);
				@include extend(fonticon--slot);
			}
			&#{$c}__table .field__sub-label:before
			{
				@include extend(fonticon);
				@include extend(fonticon--table);
			}
			&#{$c}__jackpots .field__sub-label:before
			{
				@include extend(fonticon);
				@include extend(fonticon--jackpots);
			}
			&#{$c}__video-poker .field__sub-label:before
			{
				@include extend(fonticon);
				@include extend(fonticon--video-poker);
			}
			&#{$c}__egm .field__sub-label:before
			{
				@include extend(fonticon);
				@include extend(fonticon--egm);
				position: relative;
				left: 0.12em;
			}
			&#{$c}__instant-win .field__sub-label:before
			{
				@include extend(fonticon);
				@include extend(fonticon--instant-win);
			}
		}

		.volatility-rating
		{
			width: 100%;
			display: block;

			&__container
			{
				// display: flex;
				// flex-wrap: nowrap;
				width: 100%;
				// align-content: center;
				// align-items: center;

			// 	> *
			// 	{
			// 		flex-basis: auto;
			// 		width: auto;
			// 	}
			}

			// &__title
			// {
			// 	margin-bottom: 0;
			// 	text-transform: none;
			// 	color: #666;
			// 	font-weight: normal;
			// 	font-size: 14px;
			// }

			// &__bar-wrapper
			// {
			// 	flex-grow: 1;
			// 	margin-left: 1em;
			// 	margin-right: 1em;
			// }

			&__name
			{
				min-height: 1em;
			}
		}

		&__search
		{
			color: palette(grey);
			background-color: palette(white);

			#{$c}--horizontal &
			{
				position: absolute;
				width: 472px;
				right: 0;
				top: calc(100% - 8px);
				box-shadow: inset 0 0 0 1px palette(lighter-grey), 0 4px 8px rgba(0,0,0,0.05);
				padding: rem(32);
				z-index: 99;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/organisms/AssetsFilter.vue